// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
	let blackoutTimer;

	// =========================
	// BLACKOUT (FIXED)
	// =========================
	$(".blackout").on("mouseenter", function () {
		clearTimeout(blackoutTimer);

		blackoutTimer = setTimeout(() => {
			var els = document.querySelectorAll(".showSubMenu, .show-mega");

			els.forEach((el) => {
				el.classList.remove("showSubMenu", "show-mega");
			});

			$("header .chev_a a").removeClass("show-mega flip-arrow");
			$(".menu-responsive-wrap").removeClass("show active");
			$(".menu-responsive-wrap-search").removeClass("active");
			$(".blackout").removeClass("is-active");
			$("header").removeClass("dark-head");
		}, 300);
	});

	// Cancel close if user goes back to menu
	$(".chev_a, .mega_menu_toggle, .menu-responsive-wrap").on(
		"mouseenter",
		function () {
			clearTimeout(blackoutTimer);
		},
	);

	// =========================
	// MEGA MENU
	// =========================
	$(".mega_menu_toggle").click(function () {
		$(this).toggleClass("is-active");
		$(".mega-wrap").toggleClass("is-active");
		return false;
	});

	// =========================
	// MOBILE MENU ITEMS
	// =========================
	$(".menu-responsive .menu-item-has-children").click(function (e) {
		if (!$(this).hasClass("is-active")) {
			$(this).addClass("is-active");
			e.preventDefault();
		}
	});

	$(".mobile-nav .menu-item-has-children").append(
		'<span class="open-menu far fa-chevron-right"></span>',
	);

	// =========================
	// SUB MENU LEVEL HANDLING
	// =========================
	$(".open-menu").on("click", function () {
		var level1 = document.getElementsByClassName("level-1");

		if (level1.length > 0) {
			$(this).addClass("level-2-open");
			$(this).prev(".sub-menu").addClass("level-2");
			$(this).closest(".menu-item-has-children").addClass("level-2-hold");
		} else {
			$(this).addClass("level-1-open");
			$(this).prev(".sub-menu").addClass("level-1");
			$(this).closest(".menu-item-has-children").addClass("level-1-hold");
		}

		$(".navbar-toggler").addClass("hide-menu").removeClass("open-mobile-menu");
		$(".back-menu").addClass("show-back");
		$(this).siblings().addClass("is-active");
	});

	// =========================
	// NAV LINK
	// =========================
	$(".nav__link").click(function (e) {
		e.preventDefault();
		$(this).siblings().addClass("is-active");
	});

	// =========================
	// MOBILE NAV OPEN / CLOSE
	// =========================
	// $(".open-mobile-menu").on("click", function () {
	// 	const $this = $(this);

	// 	$this.toggleClass("active");
	// 	$("body").toggleClass("menu-is-open");

	// 	setTimeout(function () {
	// 		$(".menu-responsive-wrap-mobile").toggleClass("is-active");
	// 		$(".blackout").toggleClass("is-active");
	// 	}, 400);

	// 	// delayed remove active (FIXED)
	// 	if ($this.hasClass("active")) {
	// 		setTimeout(() => {
	// 			$this.removeClass("active");
	// 		}, 400);
	// 	}

	// 	return false;
	// });

	// =========================
	// MEGA MENU HOVER CLEANUP
	// =========================
	$(".chev_a").on("mouseenter", function () {
		$(".menu-responsive-wrap-search").removeClass("show-mega-search");
		$(".blackout-search").removeClass("is-active");
	});

	// =========================
	// CLOSE MENU BUTTON
	// =========================
	// $(".close-menu").on("click", function () {
	// 	$(".menu-responsive-wrap-mobile").removeClass("is-visible");
	// });

	// =========================
	// SCROLL NAV (JQUERY)
	// =========================
	$(window).scroll(function () {
		var sc = $(window).scrollTop();

		if (sc > 100) {
			$("#navbar").addClass("sticky-nav");
		} else {
			$("#navbar").removeClass("sticky-nav");
		}
	});

	// =========================
	// HEADER SCROLL (VANILLA)
	// =========================
	const header = document.querySelector("header");
	let lastScrollY = window.scrollY;

	window.addEventListener("scroll", () => {
		const currentScrollY = window.scrollY;

		if (currentScrollY > 100 && currentScrollY < lastScrollY) {
			if (!header.classList.contains("scrolled")) {
				// Prevent content jumping
				document.body.style.paddingTop = `${header.offsetHeight}px`;

				header.classList.add("scrolled");

				// Start above the viewport
				header.style.transition = "none";
				header.style.transform = "translateY(-100%)";

				requestAnimationFrame(() => {
					header.style.transition =
						"transform 0.6s ease-in-out, box-shadow 0.6s ease-in-out";
					header.style.transform = "translateY(0)";
				});
			}
		} else {
			if (header.classList.contains("scrolled")) {
				document.body.style.paddingTop = "";
				header.classList.remove("scrolled");
				header.style.transform = "";
				header.style.transition = "";
			}
		}

		lastScrollY = currentScrollY;
	});
});

//FAQ - Pricing blocks
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".pricing-blocks .faq").forEach((faq) => {
		const trigger = faq.querySelector(".faq-q");

		if (!trigger) return;

		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			e.stopPropagation();

			faq.classList.toggle("active");
		});
	});
});

// FAQ Block
document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".faq-block").forEach((faqBlock) => {
		const questions = faqBlock.querySelectorAll(".faq-question");

		questions.forEach((question) => {
			question.addEventListener("click", () => {
				const currentItem = question.closest(".faq-item");
				const currentAnswer = currentItem.querySelector(".faq-answer");
				const currentIcon = question.querySelector("i");

				// Close all other FAQs
				faqBlock.querySelectorAll(".faq-item").forEach((item) => {
					if (item !== currentItem) {
						item.querySelector(".faq-answer").classList.add("hidden");
						item.querySelector("i").classList.remove("rotate-180");
						item.classList.remove("active");
					}
				});

				// Toggle current FAQ
				const isOpen = !currentAnswer.classList.contains("hidden");

				if (isOpen) {
					currentAnswer.classList.add("hidden");
					currentIcon.classList.remove("rotate-180");
					currentItem.classList.remove("active");
				} else {
					currentAnswer.classList.remove("hidden");
					currentIcon.classList.add("rotate-180");
					currentItem.classList.add("active");
				}
			});
		});
	});
});

//GIF
document.querySelectorAll(".hover-gif").forEach((img) => {
	const gif = img.dataset.gif;

	// No GIF? Just leave it as a normal image.
	if (!gif) return;

	const staticImg = img.dataset.static;

	img.closest(".group").addEventListener("mouseenter", () => {
		img.src = gif + "?t=" + Date.now(); // restart animation
	});

	img.closest(".group").addEventListener("mouseleave", () => {
		img.src = staticImg;
	});
});

//FAQ load more
document.addEventListener("DOMContentLoaded", () => {
	const wrapper = document.querySelector(".faq-load-more .faq-wrapper");

	if (!wrapper) return;

	const items = [...wrapper.querySelectorAll(".faq-item")];
	const button = document.querySelector(".faq-load-toggle");
	const limit = 5;
	let expanded = false;

	if (items.length <= limit) {
		button?.classList.add("hidden");
		return;
	}

	button.addEventListener("click", () => {
		expanded = !expanded;

		items.forEach((item, index) => {
			if (index >= limit) {
				item.classList.toggle("hidden", !expanded);
			}
		});

		button.textContent = expanded ? "Load Less" : "Load All";

		// Scroll back to the button when collapsing
		if (!expanded) {
			button.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
		}
	});
});

//Side CTA
// Oct 2026 QA: once closed it stays closed (30 days), and it is only shown once per
// visit (session) so it doesn't reappear on every page. Hidden on phones by CSS -
// the sticky Call / Enquire bar covers that job there.
document.addEventListener("DOMContentLoaded", () => {
	const side = document.querySelector(".side-cta");
	if (!side) return;

	const closeBtn = side.querySelector(".fa-times");
	const DISMISS_KEY = "fsSideCtaDismissedAt";
	const SEEN_KEY = "fsSideCtaSeen";
	const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

	const store = (type) => {
		try {
			return window[type];
		} catch (e) {
			return null;
		}
	};
	const local = store("localStorage");
	const session = store("sessionStorage");

	let dismissedAt = 0;
	let seenThisVisit = false;
	try {
		dismissedAt = parseInt(local && local.getItem(DISMISS_KEY), 10) || 0;
		seenThisVisit = !!(session && session.getItem(SEEN_KEY));
	} catch (e) {}

	if ((dismissedAt && Date.now() - dismissedAt < THIRTY_DAYS) || seenThisVisit) {
		side.classList.add("hide-side");
		return;
	}

	try {
		session && session.setItem(SEEN_KEY, "1");
	} catch (e) {}

	if (closeBtn) {
		closeBtn.setAttribute("role", "button");
		closeBtn.setAttribute("aria-label", "Close offer");
		closeBtn.addEventListener("click", () => {
			side.classList.add("hide-side");
			try {
				local && local.setItem(DISMISS_KEY, String(Date.now()));
			} catch (e) {}
		});
	}
});

//RAISE THIS WITH SAM, DO WE WANT TO REMEMBER THE CLOSE ON THE CTA ON MOBILE
// document.addEventListener('DOMContentLoaded', () => {
//     const side = document.querySelector('.side-cta');
//     const closeBtn = side?.querySelector('.fa-times');

//     if (!side || !closeBtn) return;

//     // Restore closed state
//     if (localStorage.getItem('sideCtaClosed') === 'true') {
//         side.classList.add('hide-side');
//     }

//     // Close and remember
//     closeBtn.addEventListener('click', () => {
//         side.classList.add('hide-side');
//         localStorage.setItem('sideCtaClosed', 'true');
//     });
// });

function checkFlexGap() {
	const flex = document.createElement("div");
	flex.style.display = "flex";
	flex.style.flexDirection = "column";
	flex.style.rowGap = "1px";

	flex.appendChild(document.createElement("div"));
	flex.appendChild(document.createElement("div"));

	document.body.appendChild(flex);

	const supported = flex.scrollHeight === 1;
	document.body.removeChild(flex);

	if (!supported) {
		document.documentElement.classList.add("no-flex-gap");
	}
}

checkFlexGap(); 
 